import { tiendanubeAutorize } from '../helpers/restHelpers'
import { processGetStatusResponse } from './appActions'

export const autorizeAction = (queryString, history) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'TIENDANUBE_STATUS_GET' })
        tiendanubeAutorize(queryString)
            .then((response) => {
                dispatch({
                    type: 'TIENDANUBE_STATUS_GET_SUCCESS',
                    payload: response,
                })
                processGetStatusResponse(response, history)
                    .then(() => resolve(response))
                    .catch((error) => reject(error))
            })
            .catch((error) => {
                dispatch({
                    type: 'TIENDANUBE_STATUS_GET_FAILURE',
                    payload: error,
                })
                reject(error)
            })
    })
